<script>
export default {
  name: "EmptyEvents",
};
</script>

<template>
  <div class="my-10">
    <v-card flat class="d-flex flex-column align-center justify-center">
      <v-img src="/empty.svg" max-width="200" />
      <v-card-title class="text--primary">
        <span class="font-weight-bold mb-3" style="word-break: break-word">
          No upcoming events at the moment.
        </span>
      </v-card-title>
    </v-card>
  </div>
</template>
